module.exports = __webpack_public_path__ + "static/media/contact.ac2a01b6.png";